import { DragIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
export const panelContentContainerSectionCss = "p14tm0ai";
export const panelContentContainerSubsectionCss = "p19bpcn5";
const panelContentContainerCss = "pzwsopb";
export const PanelContentContainer = forwardRef((props, ref) => {
  const {
    section,
    subsection,
    ...restProps
  } = props;
  return <section ref={ref} {...restProps} className={classNames(panelContentContainerCss, {
    [panelContentContainerSectionCss]: section,
    [panelContentContainerSubsectionCss]: subsection
  }, props.className)} />;
});
const panelContentHeaderIsLockedCss = "p164aj7h";
const panelContentHeaderWithActionsCss = "pemzxuq";
const panelContentHeaderCss = "p1k4fpdx";
export const PanelContentHeader = forwardRef((props, ref) => {
  const {
    isLocked,
    withActions,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(panelContentHeaderCss, {
    [panelContentHeaderIsLockedCss]: isLocked,
    [panelContentHeaderWithActionsCss]: withActions
  }, props.className)} />;
});
const panelContentTitleCss = "p1ni3d9l";
export const PanelContentTitle = forwardRef((props, ref) => <BodyText ref={ref} {...props} className={classNames(panelContentTitleCss, props.className)} />);
const panelContentSubtitleCss = "p1cjexn0";
export const PanelContentSubtitle = forwardRef((props, ref) => {
  const size = 'small';
  const color = 'muted';
  return <BodyText ref={ref} {...props} size={size} color={color} className={classNames(panelContentSubtitleCss, props.className)} />;
});
const panelContentValueLockedCss = "p10r2kpx";
export const PanelContentValueLocked = forwardRef((props, ref) => {
  const size = 'small';
  const color = 'muted';
  const weight = 'bold';
  return <BodyText ref={ref} {...props} size={size} color={color} weight={weight} className={classNames(panelContentValueLockedCss, props.className)} />;
});
export const SubsectionItemHeader = props => <Layout relative gap="4" justify="space-between" align="center" {...props} />;
const sectionLockContainerIsPhoneCss = "s1geiqqd";
const sectionLockContainerCss = "s1ndnw38";
export const SectionLockContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(sectionLockContainerCss, {
    [sectionLockContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const SectionLockInputLabel = props => <Layout justify="start" align="center" {...props} />;
const listItemCss = "l1ozwnok";
export const ListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(listItemCss, props.className)} />;
});
const unorderedListCss = "u140t6j9";
export const UnorderedList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(unorderedListCss, props.className)} />;
});
const buttonLabelDisabledCss = "b1jy01sw";
const buttonLabelCss = "b1fbjuqe";
export const ButtonLabel = forwardRef((props, ref) => {
  const {
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonLabelCss, {
    [buttonLabelDisabledCss]: disabled
  }, props.className)} />;
});
const trimmedSubheaderCss = "t9qf344";
export const TrimmedSubheader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(trimmedSubheaderCss, props.className)} />;
});
const inputContainerCss = "ijn47gp";
export const InputContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inputContainerCss, props.className)} />;
});
const inlineEditingContainerIsDraggingCss = "i92x4a4";
const inlineEditingContainerCss = "iz5x7qv";
export const InlineEditingContainer = forwardRef((props, ref) => {
  const {
    isDragging,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inlineEditingContainerCss, {
    [inlineEditingContainerIsDraggingCss]: isDragging
  }, props.className)} />;
});
export const HeaderWithIcon = props => <Layout gap="4" align="center" {...props} />;
const styledDragIconCss = "s10uy3w6";
export const StyledDragIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledDragIconCss, props.className)}>
      <DragIcon inline />
    </Component>;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");